class CollapseMenu {
  constructor(tab) {
    this.tabItems = [
      { name: 'entities', btn: 'btn-entities' },
      { name: 'invoices', btn: 'btn-invoices' },
      { name: 'consumption-details', btn: 'btn-consumption-details' },
      { name: 'users', btn: 'btn-users' },
      { name: 'general-data', btn: 'btn-general-data' },
      { name: 'integration-data', btn: 'btn-integration-data' },
    ]
    this.jQuery = window.$

    const tabItem = this.tabItems.find((item) => item.name === tab)

    this.activeTab(tabItem)
    this.setCurrentTabUrlParam(tabItem.name)
    this.addEventCollapseHideAll(this)
  }

  activeTab(tabItem) {
    this.jQuery(`#${tabItem.btn}`).addClass('active')
  }

  setCurrentTabUrlParam(tabName) {
    const url = new URL(window.location)

    url.searchParams.set('current_tab', tabName)

    window.history.pushState(null, '', url)
  }

  addEventCollapseHideAll(self) {
    self.jQuery('.collapse-menu-btn').click(() => {
      self.jQuery('[id^="collapse-account-user-permissions-"].show').collapse('hide')
      self.jQuery('[id^="collapse-entities-for-user-"].show').collapse('hide')
    })
  }
}

export default CollapseMenu
